import { useEffect, useState } from "react";
import api from "@/lib/api";

// Member direct Call/Text line: assigned advisor's line, else founder attribution, else verified SBA main line.
export function useAdvisorLine() {
  const [line, setLine] = useState(null);
  useEffect(() => {
    let off = false;
    api.get("/telephony/config").then((r) => r.data).catch(() => null).then(async (cfg) => {
      if (cfg?.available) return { phone: cfg.business_number, smsReady: !!cfg.text_available, label: "my agent", assigned: true };
      const r = await api.get("/consumer/ask/advisor-contact").catch(() => null);
      const d = r?.data;
      return d?.business_phone ? { phone: d.business_phone, smsReady: !!d.sms_ready, label: d.label, assigned: false } : null;
    }).then((l) => { if (!off) setLine(l); });
    return () => { off = true; };
  }, []);
  return line;
}
